import './PageHeader.css';

/**
 * Шапка внутренней страницы: метка, заголовок, вводный абзац.
 *
 * @param {object} props
 * @param {string} [props.eyebrow]
 * @param {string} props.title
 * @param {string} [props.lead]
 * @param {import('react').ReactNode} [props.meta] — строка технических данных под текстом
 */
function PageHeader({ eyebrow, title, lead, meta }) {
  return (
    <div className="page-header">
      <div className="page-header__glow" aria-hidden="true" />
      <div className="container page-header__inner">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="page-header__title">{title}</h1>
        {lead && <p className="lead page-header__lead">{lead}</p>}
        {meta && <div className="page-header__meta">{meta}</div>}
      </div>
    </div>
  );
}

export default PageHeader;
